import { DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Feriado from "model/administracao/cadastro/Feriado";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import FeriadoService from "service/administracao/cadastro/FeriadoService";

const feriadoService = new FeriadoService();

export default function FeriadoCadastro() {

    const [queryParameters] = useSearchParams();

    const { setError, formState: { errors }, register, clearErrors, control } = useForm();

    const [feriado, setFeriado] = useState<Feriado>(new Feriado());

    useEffect(() => {
    }, []);

    function validar() {

        if (!feriado.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (!feriado.data) {
            setError("data", { type: "manual", message: "Data é obrigatória" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    return (

        <BaseCadastro model={feriado} service={feriadoService} setModel={(value: Feriado) => {
            setFeriado(value);
        }} validar={() => validar()} urlService="/feriado" pathCadastro="/feriado" tituloPagina={'Feriados'}>

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={feriado.replicaAnualmente}
                    onChange={(e) => { setFeriado({ ...feriado, replicaAnualmente: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Replicar anualmente?</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={feriado.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setFeriado({ ...feriado, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data</Label>
                <div className="col-sm-12">

                    <Controller name="data" control={control} render={({ field }) => (
                        <DateTimePicker
                            inputRef={field.ref}
                            value={dayjs(feriado.data)}
                            ampm={false}
                            className="data-feriado"
                            views={feriado.replicaAnualmente ? ['day', 'month'] : ['day', 'month', 'year']}
                            format={feriado.replicaAnualmente ? "DD/MM" : "DD/MM/YYYY"}
                            onChange={value => {
                                clearErrors("data")
                                setFeriado({ ...feriado, data: value?.toDate() || null })
                            }}
                        />
                    )} />

                </div>
                {errors.data && errors.data.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.data?.message as string}</span> : null}
            </div>

        </BaseCadastro>
    )
}
